import "../../../styles/kjedeweb/chainProductView.scss";

import Icon, { iconColor, iconTypes } from "../../common/components/Icon";
import { SubMenu, SubMenuItem } from "../../common/components/SubMenu.jsx";
import { getInvoiceGroups, updateChainProducts } from "../actions/singleChainSortiment.js";
import { getInvoiceGroups as getInvoiceGroupsMultiChain, updateChainProducts as updateChainProductsMultiChain } from "../actions/multiChainSortiment.js";

import Calendar from "../../common/components/Calendar";
import DropDownList from "../../common/components/DropDownList";
import LabelField from "../../common/components/LabelField";
import { Localization } from "../../common/util/localization.jsx";
import Modal from "../../common/components/Modal.jsx";
import PropTypes from "prop-types";
import React from "react";
import TextField from "../../common/components/TextField.jsx";
import { connect } from "react-redux";
import { downloadHmsPdf } from "../../kundeweb/util/productUtil.jsx";
import moment from "moment";
import { setDropDown } from "../../common/actions/modal.js";

/**
 * Returnerar kalender komponent
 * 
 * @param {object} props
 * @returns {node}
 */
function CalendarDropdown({ onClickHide, dropDown, localization, date, validDates, previousDates, nextOrderDate, onSelectDate }) {
    /**
     * selects the date and hides the dropdown window
     * 
     * @param {object} date
     * @returns {undefined}
     */
    function onClick(date) {
        onClickHide();
        onSelectDate(date);
    }

    const minDate = moment(new Date());
    const maxDate = moment("2100-01-01");

    return (
        <Calendar localization={localization} dropDown={dropDown} date={date} validDates={validDates} previousDates={previousDates} nextOrderDate={nextOrderDate} onSelectDate={onClick} minDate={minDate} maxDate={maxDate} deliveryDates={[]} newSeasonDistrDates={[]}/>
    );
}
CalendarDropdown.propTypes = {
    date: PropTypes.string,
    dropDown: PropTypes.bool,
    localization: Localization.propTypes.isRequired,
    nextOrderDate: PropTypes.string,
    onClickHide: PropTypes.func,
    onSelectDate: PropTypes.func,
    previousDates: PropTypes.arrayOf(PropTypes.string.isRequired),
    validDates: PropTypes.arrayOf(PropTypes.string.isRequired),
};



class MultiProductModal extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {

        };

        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.onSaveChanges = this.onSaveChanges.bind(this);
        this.onSelectAdmDate = this.onSelectAdmDate.bind(this);
        this.onSelectDate = this.onSelectDate.bind(this);
        this.onEdit = this.onEdit.bind(this);
    }

    componentDidMount() {
        const {
            isMultiChain,
            getInvoiceGroups,
            getInvoiceGroupsMultiChain,
        } = this.props;
        (async () => {
            if(isMultiChain){
                await getInvoiceGroupsMultiChain();
            } else {
                await getInvoiceGroups();
            }
        })();
    }

    handleClickOutside() {
        if (this.props.onCloseModal) {
            this.props.onCloseModal();
        }
    }

    onSelectDate(date) {
        this.setState({
            futureEndPriceDate: date  // update the value of specific key
        });
    }
    onSelectAdmDate(date) {
        this.setState({
            futureAdminChargeDate: date  // update the value of specific key
        });
    }

    capitalizeFirstLetter(s) {
        s = s.toLowerCase();
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    validateNewPrice() {
        return true;
    }

    getDropDownDateStyle() {
        return {
            width: "450px",
            left: "unset",
            right: "0px",
            top: "30px",
        };
    }

    onSaveChanges(event) {
        const {
            isMultiChain,
            chainType,
            selected,
            updateChainProducts,
            updateChainProductsMultiChain,
            onCloseModal,
        } = this.props;
        const products = [];
        for(const key in selected) {
            products.push({
                ...selected[key],
                ...this.state,
            });
        }
        if( isMultiChain ){
            updateChainProductsMultiChain(products);
        } else {
            updateChainProducts(chainType, products);
        }
        onCloseModal(event);
    }

    onEdit(change) {
        this.setState(change);
    }


    render() {
        const {
            invoiceGroups,
            localization,
            onCloseModal,
            saveButtonText,
            width,
            setDropDown,
        } = this.props;

        const invoiceGroupOptions = invoiceGroups.map(ig => { return { value: ig.invoiceCode, label: this.capitalizeFirstLetter(ig.description) }; });

        const futureEndPriceDateForDropdown = !this.state.futureEndPriceDate ? moment() : moment(this.state.futureEndPriceDate);
        const futureEndPriceDateForDisplay = !this.state.futureEndPriceDate ? "Sett dato" : moment(this.state.futureEndPriceDate).format("DD.MM.YYYY");

        const futureAdmDateForDropDown = !this.state.futureAdminChargeDate ? moment() : moment(this.state.futureAdminChargeDate);
        const futureAdmDateForDisplay = !this.state.futureAdminChargeDate ? "Sett dato" : moment(this.state.futureAdminChargeDate).format("DD.MM.YYYY");

        const previousDates = [];
        const validDates = [];

        return (
            <Modal onCloseModal={onCloseModal} width={width} onClickOutside={this.handleClickOutside}>
                <div className="chain-product-modal-wrapper">
                    <div className="product-modal-header">
                        <div className="header-content">
                            <div className="header-left">
                                <div className="header-detail">{localization.text("chain","editMultiple")}</div>
                                <div className="header-name-epd">
                                    <div className="header-prd-name">{localization.text("chain","multiModalInfo1")}</div>
                                    <div className="header-epdNo" style={{paddingLeft:"1rem"}}>{localization.text("chain","multiModalInfo2")}</div>
                                </div>
                            </div>
                            <button style={{ marginLeft: "auto" }} className="btn circular" onClick={onCloseModal}>
                                <Icon type={iconTypes.x} color={iconColor.red} />
                            </button>
                        </div>
                    </div>
                    <div className="product-modal-body">
                        <div className="product-modal-rightsidebar">
                            <div className="product-modal-edit-wrapper">
                                <div className="product-modal-edit-header" style={{ flex: 0.7 }}>{/*<LabelField label={localization.text("chain","productStatus")} isRequired={true}/>*/}</div>
                                <div className="product-modal-edit-header">{/*<LabelField label={localization.text("chain","productCatalog")} isRequired={true}/>*/}</div>
                                <div className="product-modal-edit-header" style={{ flex: 1.2 }}><LabelField label={localization.text("chain","invoiceGroup")} isRequired={true}/></div>
                                <div className="product-modal-edit-header"><LabelField label={localization.text("chain","retailPrice")} isRequired={true}/></div>
                                <div className="product-modal-edit-header" style={{ flex: 0.8 }}><LabelField label={localization.text("chain","adminFee")} isRequired={true}/></div>
                            </div>
                            <div className="product-modal-edit-row-wrapper">
                                <div className="product-modal-edit-row " style={{ flex: 0.7 }}>
                                    <div style={{width:"90%"}}>
                                        {/* <DropDownList strongBorder={true} selectedIconType={iconAvailable} options={statusOptions} onEdit={this.onEdit} source={this.state} property={"inCatalogue"} value={this.state.inCatalogue} setDropDown={setDropDown} /> */}
                                    </div>
                                </div>
                                <div className="product-modal-edit-row">
                                    <div style={{width:"90%"}}>
                                        {/*<DropDownList strongBorder={true} selectedIconType={iconInCatalogue} options={catalogueOptions} onEdit={this.onEdit} source={this.state} property={"inCatalogue"} value={this.state.inCatalogue} setDropDown={setDropDown} />*/}
                                    </div>
                                </div>
                                <div className="product-modal-edit-row " style={{ flex: 1.2 }}>
                                    <div style={{width:"90%"}}>
                                        <DropDownList strongBorder={true} options={invoiceGroupOptions} onEdit={this.onEdit} source={this.state} property={"invoiceGroupId"} value={this.state.invoiceGroupId} setDropDown={setDropDown} />
                                    </div>
                                </div>
                                <div className="product-modal-edit-row">
                                    <div className="header">
                                    </div>
                                    <TextField
                                        className="input-container product-modal-edit-price"
                                        onEdit={this.onEdit}
                                        onChange={this.onEdit}
                                        smallText={true}
                                        source={this.state}
                                        property={"futureEndPrice"}
                                        placeholder={localization.text("chain", "newPrice")}
                                        disabled={false}
                                        type="number"
                                        validation={this.validateNewPrice} />
                                    <div className="product-modal-edit-date">
                                        <SubMenu border={false} style={{ width: "90%", height: "30px", display:"flex",  }}>
                                            <SubMenuItem iconType={iconTypes.calender} style={{width:"100%",paddingTop:"4px",alignItems:"center"}} border={false} children={(<div className="product-modal-edit-date-val noselect">{futureEndPriceDateForDisplay}</div>)} flex={true} disableDimScreen={true} dropDownStyle={this.getDropDownDateStyle()} expand={true} setDropDown={setDropDown} dropDownChildren={(
                                                <CalendarDropdown localization={localization} dropDown={true} date={futureEndPriceDateForDropdown.format("YYYY-MM-DD")} validDates={validDates} previousDates={previousDates} nextOrderDate={""} onSelectDate={this.onSelectDate} deliveryDates={[]} newSeasonDistrDates={[]}/>
                                            )} />
                                        </SubMenu>
                                    </div>
                                </div>
                                <div className="product-modal-edit-row" style={{ flex: 0.8 }}>
                                    <div className="header">
                                    </div>
                                    <TextField
                                        className="input-container product-modal-edit-price"
                                        onEdit={this.onEdit}
                                        onChange={this.onEdit}
                                        smallText={true}
                                        source={this.state}
                                        property={"futureAdminCharge"}
                                        placeholder={localization.text("chain", "newFee")}
                                        disabled={false}
                                        type="number"
                                        validation={this.validateNewPrice} />
                                    <div className="product-modal-edit-date">
                                        <SubMenu border={false} style={{ width: "90%", height: "30px", display:"flex" }}>
                                            <SubMenuItem iconType={iconTypes.calender} style={{width:"100%",paddingTop:"4px",alignItems:"center"}} border={false} children={(<div className="product-modal-edit-date-val">{futureAdmDateForDisplay}</div>)} flex={true} disableDimScreen={true} dropDownStyle={this.getDropDownDateStyle()} expand={true} setDropDown={setDropDown} dropDownChildren={(
                                                <CalendarDropdown localization={localization} dropDown={true} date={futureAdmDateForDropDown.format("YYYY-MM-DD")} validDates={validDates} previousDates={previousDates} nextOrderDate={""} onSelectDate={this.onSelectAdmDate} />
                                            )} />
                                        </SubMenu>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="product-modal-footer">
                        <div style={{ flex: 3 }}>
                            
                        </div>
                        <div className="product-modal-footer-button">
                            <button style={{ flexGrow: 1, marginRight: "15px" }} className="btn" onClick={onCloseModal}>
                                <Icon type={iconTypes.x} color={iconColor.red} /> {localization.text("chain", "undo")}
                            </button>
                            <button style={{ flexGrow: 1 }} className="btn" onClick={this.onSaveChanges} disabled={true}>
                                {saveButtonText}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}
MultiProductModal.propTypes = {
    chainType: PropTypes.number.isRequired,
    downloadHmsPdf: PropTypes.func.isRequired,
    getInvoiceGroups: PropTypes.func.isRequired,
    invoiceGroups: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    localization: Localization.propTypes.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    saveButtonText: PropTypes.string,
    token: PropTypes.string.isRequired,
    updateChainProducts: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    selected: PropTypes.object.isRequired,
    isMultiChain: PropTypes.bool.isRequired,
    getInvoiceGroupsMultiChain: PropTypes.func.isRequired,
    updateChainProductsMultiChain: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
};

const mapStateToProps = () => {
    return (state) => ({
        isMultiChain: state.authentication.chainIds.length>1,
        chainType: state.authentication.chainType,
        deviceType: state.view.deviceType,
        invoiceGroups: state.singleChainSortiment.invoiceGroups,
        isLoading: state.singleChainSortiment.isLoading,
        token: state.authentication.token,
    });
};

const mapDispatchToProps = {
    downloadHmsPdf,
    getInvoiceGroups,
    getInvoiceGroupsMultiChain,
    updateChainProducts,
    updateChainProductsMultiChain,
    setDropDown,
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiProductModal);
